import React from 'react';
import { Box, styled, useTheme } from '@mui/material';

import { Typography } from '@zendesk/forethought-elements';

interface ComparisonRowProps {
  rows: {
    color: string;
    firstColumnText: string;
    label: string;
    secondColumnText: string;
  }[];
}

export const ComparisonRows = ({ rows }: ComparisonRowProps) => {
  const { palette } = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}
    >
      {rows.map((row, index, arr) => (
        <React.Fragment key={row.label}>
          <Box sx={{ alignItems: 'center', display: 'flex', flex: 1 }}>
            <Box
              sx={{
                alignItems: 'center',
                display: 'flex',
                flex: 1,
                gap: '4px',
              }}
            >
              <Box
                sx={{
                  backgroundColor: row.color,
                  borderRadius: '2px',
                  height: '12px',
                  width: '12px',
                }}
              />
              <Typography variant='font14'>{row.label}</Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flex: 1,
                justifyContent: 'flex-end',
              }}
            >
              <Typography variant='font14Bold'>
                {row.firstColumnText}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flex: 1,
                justifyContent: 'flex-end',
              }}
            >
              <Typography color={palette.grey[700]} variant='font14'>
                {row.secondColumnText}
              </Typography>
            </Box>
          </Box>
          {index < arr.length - 1 && <Separator />}
        </React.Fragment>
      ))}
    </Box>
  );
};

const Separator = styled('div')`
  height: 1px;
  background: rgba(0, 0, 0, 0.1);
  width: 100%;
`;
